import script from "./servicedetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./servicedetail.vue?vue&type=script&setup=true&lang=ts"

import "./servicedetail.vue?vue&type=style&index=0&id=9076f4cc&scoped=true&lang=scss"

import exportComponent from "D:\\全部项目\\funeral-and-interment\\publicnumber\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9076f4cc"]])

export default __exports__